import React from "react";
import { AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import api from "@/lib/api";
import { toast } from "sonner";

export default function DeleteProjectButton({ projectId, onDeleted, className = "", label = false }) {
  const { t } = useLang();

  const doDelete = async () => {
    try {
      await api.delete(`/projects/${projectId}`);
      toast.success(t("del.done"));
      onDeleted?.();
    } catch (e) {
      toast.error("—");
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          data-testid={`delete-project-${projectId}`} aria-label={t("del.trigger")}
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center gap-1.5 text-slate-400 hover:text-red-500 transition-colors ${className}`}
        >
          <Trash2 size={16} />{label && <span className="text-sm">{t("del.trigger")}</span>}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="rounded-2xl" data-testid="delete-confirm" onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("del.title")}</AlertDialogTitle>
          <AlertDialogDescription>{t("del.body")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-full" data-testid="delete-cancel">{t("del.cancel")}</AlertDialogCancel>
          <AlertDialogAction data-testid="delete-confirm-btn" onClick={doDelete} className="rounded-full bg-red-500 hover:bg-red-600">
            {t("del.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
